var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailerMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 23,
    width: 28,
    height: 3,
    fill: "#575656"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 21,
    width: 4,
    height: 5,
    fill: "#575656"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 21,
    width: 1,
    height: 5,
    fill: "#575656"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 29C11.1046 29 12 28.1046 12 27C12 25.8954 11.1046 25 10 25C8.89543 25 8 25.8954 8 27C8 28.1046 8.89543 29 10 29ZM10 26C10.5523 26 11 26.4477 11 27C11 27.5523 10.5523 28 10 28C9.44772 28 9 27.5523 9 27C9 26.4477 9.44772 26 10 26Z",
    fill: "#575656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 29C14.1046 29 15 28.1046 15 27C15 25.8954 14.1046 25 13 25C11.8954 25 11 25.8954 11 27C11 28.1046 11.8954 29 13 29ZM13 26C13.5523 26 14 26.4477 14 27C14 27.5523 13.5523 28 13 28C12.4477 28 12 27.5523 12 27C12 26.4477 12.4477 26 13 26Z",
    fill: "#575656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 29C25.1046 29 26 28.1046 26 27C26 25.8954 25.1046 25 24 25C22.8954 25 22 25.8954 22 27C22 28.1046 22.8954 29 24 29ZM24 26C24.5523 26 25 26.4477 25 27C25 27.5523 24.5523 28 24 28C23.4477 28 23 27.5523 23 27C23 26.4477 23.4477 26 24 26Z",
    fill: "#575656"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 29C28.1046 29 29 28.1046 29 27C29 25.8954 28.1046 25 27 25C25.8954 25 25 25.8954 25 27C25 28.1046 25.8954 29 27 29ZM27 26C27.5523 26 28 26.4477 28 27C28 27.5523 27.5523 28 27 28C26.4477 28 26 27.5523 26 27C26 26.4477 26.4477 26 27 26Z",
    fill: "#575656"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10H30V23H8V10ZM11 12H12V21H11V12ZM15 12H14V21H15V12ZM17 12H18V21H17V12ZM21 12H20V21H21V12ZM23 12H24V21H23V12ZM27 12H26V21H27V12Z",
    fill: "#575656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerMaterial);
export default __webpack_public_path__ + "static/media/TRAILER_MATERIAL.075f7a7bc77650828fba942ab7d85f37.svg";
export { ForwardRef as ReactComponent };